import styled from "styled-components"

import { media } from "src/uikit"

export const Container = styled.section`
  padding: 0 16px;

  .inner {
    background-color: #f7f7fc;
    border-radius: 24px;
    max-width: 1000px;
    height: 340px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .logos {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: -48px;
  }

  .text {
    margin-top: -120px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 800;
    font-size: 48px;
    line-height: 64px;
    text-align: center;
    color: #142470;
    margin-bottom: 16px;
  }

  p {
    margin: 0;
    font-size: 17px;
    line-height: 32px;
    text-align: center;
    letter-spacing: 0.5px;
    color: #142470;
  }

  @media ${media.tablet} {
    .inner {
      max-width: 688px;
    }

    .logos {
      bottom: -72px;
    }
  }

  @media ${media.mobile} {
    .inner {
      max-width: 288px;
      height: 211px;
    }

    .text {
      max-width: 256px;
      margin-top: -56px;
    }

    .logos {
      bottom: -32px;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-size: 26px;
      line-height: 32px;
      margin-bottom: 8px;
    }

    p {
      font-size: 15px;
      line-height: 28px;
      letter-spacing: 0.4px;
    }
  }
`

export const Logo = styled.div`
  width: 286px;
  height: 152px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: rgba(39, 49, 142, 0.2) 0px 10px 30px -10px;

  :first-child {
    margin-right: 36px;
  }

  :last-child {
    margin-left: 36px;
  }

  svg {
    max-width: 100%;
  }

  @media ${media.tablet} {
    :first-child {
      margin-right: 20px;
    }

    :last-child {
      margin-left: 20px;
    }
  }

  @media ${media.mobile} {
    width: 120px;
    height: 70px;

    box-shadow: rgba(39, 49, 142, 0.2) 0px 10px 11px -10px;

    svg {
      width: 100px;
    }

    :first-child {
      margin-right: 8px;
    }

    :last-child {
      margin-left: 8px;
    }
  }
`
